import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { Button, Dropdown, Modal } from "semantic-ui-react";
import { setSiteAllocatedModal } from "@actions/modals";
import { fetchProfileBySite } from "@api/settings";
import DataGrid from "../shared/DataGrid";
import { changeProfile, fetchProfileOptions } from "../../api/settings";
import { mapToSelect } from "../../api/egm";
import LoadingAction from "@common/redux/actions/LoadingAction";
import { handleError } from "@common/components/helpers/error";
import AlertModalAction from "@common/redux/actions/AlertModalAction";

const SiteAllocatedModal = (props) => {
  const {
    open,
    selectedOperator,
    selectedProfile,
    profileBySite,
    profileOptions,
    profileValue,
    loading,
    row,
  } = useSelector((state) => state.siteAllocatedModal);

  const onClose = () => {
    props.setSiteAllocatedModal({
      open: false,
      showDropdown: false,
      row: null,
    });
  };

  const onRowClick = (row) => {
    props.setSiteAllocatedModal({ row });
  };

  const onChangeProfile = (e, { value }) => {
    props.setSiteAllocatedModal({ profileValue: value });
  };

  const onChangeProfileClick = () => {
    LoadingAction.set(true).then(() =>
      changeProfile(selectedOperator, row?.siteId, profileValue)
        .then(() => {
          LoadingAction.set(false);
        })
        .catch(handleError)
        .finally(() =>
          AlertModalAction.open("Profile updated!", "Success", onRefresh),
        ),
    );
  };

  const setLoading = (loading) => props.setSiteAllocatedModal({ loading });
  const onRefresh = () => {
    if (!selectedOperator || !selectedProfile) {
      return;
    }

    setLoading(true);
    fetchProfileBySite(selectedOperator, selectedProfile.profileId).then(
      (response) => {
        props.setSiteAllocatedModal({ profileBySite: response });
        fetchProfileOptions(selectedOperator)
          .then((profileOptions) => {
            props.setSiteAllocatedModal({ profileOptions });
          })
          .finally(() => setLoading(false));
      },
    );
  };
  useEffect(onRefresh, [selectedOperator, selectedProfile]);

  return (
    <Modal open={open} closeIcon onClose={onClose}>
      <Modal.Header>Sites Allocated</Modal.Header>
      <Modal.Content>
        <>
          <div className="justify-between items-center pb-1">
            <p className="text-lg">
              {profileBySite?.profileName ?? selectedProfile?.profileName}
            </p>
            <div>
              {row && (
                <>
                  <Dropdown
                    className="border border-radius px-1 py-0_5 mr-1"
                    placeholder="Select Profile"
                    options={mapToSelect(profileOptions)}
                    value={profileValue}
                    onChange={onChangeProfile}
                  />
                  <Button
                    content="Change Profile"
                    disabled={!row}
                    color="blue"
                    onClick={onChangeProfileClick}
                  />
                </>
              )}
            </div>
          </div>
          <DataGrid
            headings={profileBySite?.grid?.headerDef}
            rowDef={profileBySite?.grid?.rowDef}
            loading={loading}
            data={profileBySite?.grid?.data}
            onRowClick={onRowClick}
            fullHeight
            style={{ height: "65vh" }}
          />
        </>
      </Modal.Content>
      <Modal.Actions>
        <Button positive onClick={onClose}>
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default connect(null, { setSiteAllocatedModal })(SiteAllocatedModal);
